/* 🤖 this file was generated by svg-to-ts */
export const iconEthx: {
  name: 'ethx';
  data: string;
} = {
  name: 'ethx',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="none" viewBox="0 0 32 33"><path fill="currentColor" d="M16 .43c-8.84 0-16 7.16-16 16s7.16 16 16 16 16-7.16 16-16-7.16-16-16-16m0 7.95 4.86 8.21-4.86 2.9-4.85-2.91zM5.13 10.01l4.46-4.46 1.89 1.89c-1.92.97-3.49 2.53-4.47 4.45zm4.46 17.35L5.13 22.9l1.89-1.89c.98 1.92 2.55 3.48 4.48 4.44zm1.54-9.82 4.86 2.91 4.86-2.86-4.86 6.9zm11.35 9.82-1.93-1.94c1.92-.97 3.49-2.54 4.45-4.47l1.94 1.94-4.46 4.46zm2.53-15.42c-.96-1.93-2.52-3.5-4.44-4.48l1.91-1.91 4.46 4.46z"/></svg>`,
};
